module.exports = __webpack_public_path__ + "media/images/categories/introversion-11a9f8d0a5175a1af807540744d1295f.png";